// biome-ignore format: historic
import { useCallback, useState } from 'react';

export type SettableNode<T> = [T | undefined, React.RefCallback<T>];
/**
 * Utilises a callback ref to get access to a node and store it in state. This is very useful
 * if we want to be able to react to an Element mounting and unmounting, since regular refs do
 * not cause rerenders.
 */
export default function useNode<T extends HTMLElement | SVGElement>(): SettableNode<T> {
  const [node, setNode] = useState<T>();

  // https://reactjs.org/docs/refs-and-the-dom.html#caveats-with-callback-refs
  const ref = useCallback((node: T | null) => {
    if (node !== null) {
      setNode(node);
    }
  }, []) as React.RefCallback<T>;
  return [node, ref];
}
